
import { reactive, ref, toRefs, unref, onMounted, defineComponent } from "vue";
//引入vue方法
 import Edit from "./Edit.vue";
import { ElConfigProvider } from "element-plus";
import type { ElForm } from 'element-plus';
//中文包
import { useRouter } from "vue-router";
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import { getAttract ,delAttract ,getAllAttractType} from "@/api/backstage";
import { ElMessage } from "element-plus";
import { getEnum } from "@/api/index";
type FormInstance = InstanceType<typeof ElForm>;

export default defineComponent({
  name: "招聘管理",
  components: {
    [ElConfigProvider.name]: ElConfigProvider,
    Edit,
  },
  setup() {
    let locale = zhCn;
    const router = useRouter();
    const dataMap: any = reactive({
      ruleFormRef: ref<FormInstance>(),
      dialogVisible: false,
      rows:'',
      attrType:'',
      tableData: [],
      total: 0,
      time: "",
      form: {
        title: "",
        typeId:'',
        pageNum: 1,
        pageSize: 10,
      },
      async getList() {
        const data = await getAttract(this.form);
        dataMap.tableData = data?.data.list ?? [];
        dataMap.total = data?.data.total ?? 0;
      },
      async getAttractType() {
        const res = await getAllAttractType();
         dataMap.attrType = res?.data ?? [];
      },
 
      async delDataList(ids: any) {
        const baseId = { id: ids };
        const res = await delAttract(baseId);
        if (res.code === 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
          dataMap.getList();
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      },
    });
    const onSubmit = () => {
      dataMap.getList();
    };

    const resetForm = (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      formEl.resetFields();
      dataMap.getList();
    };

    const handleSizeChange = (val: number) => {
      dataMap.form.pageSize = val;
      dataMap.getList();
    };
    const handleCurrentChange = (val: number) => {
      dataMap.form.pageNum = val;
      dataMap.getList();
    };
 
    const addClick = (row: any) => {
      dataMap.dialogVisible = true;
      dataMap.rows = "";
    };

    const close = (val: any) => {
      dataMap.dialogVisible = false;
      dataMap.getList();
    };
    const confirmEvent = (row: any, index: any) => {
      dataMap.delDataList(row.id);
    };
    const editClick = (row: any) => {
      dataMap.dialogVisible = true;
      dataMap.rows = row;
    };
    onMounted(() => {
      dataMap.getList();
      dataMap.getAttractType();
    });

    return {
      locale,
      close,
      onSubmit,
      resetForm,
      router,
      addClick,
      editClick,
      confirmEvent,
      handleSizeChange,
      handleCurrentChange,
      ...toRefs(dataMap),
    };
  },
});
